"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProgressIndicator = ({ type, width, strokeWidth, percentage, backgroundColor, color, }) => {
    if (type === 'circular') {
        const radius = (width - strokeWidth) / 2;
        const viewBox = `0 0 ${width} ${width}`;
        const dashArray = radius * Math.PI * 2;
        const dashOffset = dashArray - (dashArray * percentage) / 100;
        return (core_1.jsx("svg", { width: width, height: width, viewBox: viewBox },
            core_1.jsx("circle", { css: styled_react_1.circleBackgroundDynamicStyle(backgroundColor), cx: width / 2, cy: width / 2, r: radius, strokeWidth: `${strokeWidth}px` }),
            core_1.jsx("circle", { css: styled_react_1.circleProgressDynamicStyle(color, dashArray, dashOffset), cx: width / 2, cy: width / 2, r: radius, strokeWidth: `${strokeWidth}px`, transform: `rotate(-90 ${width / 2} ${width / 2})` })));
    }
    if (type === 'linear') {
        return (core_1.jsx("div", { css: styled_react_1.linearProgressDynamicStyle(width, strokeWidth, backgroundColor) },
            core_1.jsx("div", { css: styled_react_1.linearProgressBarDynamicStyle(percentage, color) })));
    }
    return null;
};
ProgressIndicator.defaultProps = {
    type: 'circular',
    width: undefined,
    strokeWidth: undefined,
    backgroundColor: styles_scss_1.default.lightGrey,
    color: styles_scss_1.default.primary,
};
exports.default = ProgressIndicator;
